import { configureStore } from '@reduxjs/toolkit';
import type { RootState } from 'src/reducers/model';
import { rootReducer } from 'src/reducers/reduxer';
// import { createInjectorsEnhancer } from 'redux-injectors';

// Create store - only for client-side
const store = (preloadedState?: Partial<RootState>) =>
  configureStore({
    reducer: rootReducer,
    devTools: process.env.NODE_ENV !== 'production',
    preloadedState,
  });

export default store;
